export const SELECT = 'CHESS_BOARD/SELECT';
export const MOVE_TO = 'CHESS_BOARD/MOVE_TO';
export const SET_BOARD = 'CHESS_BOARD/SET_BOARD';
